/* eslint-disable no-inline-styles/no-inline-styles */
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, Typography, useTheme } from '@mui/material';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { Loader } from '../../global/index';
import { Unauthorized } from '../Auth';
import {
  PmEnrollment,
  CombineExcel,
  ExpoCompile,
  ErrorChecking,
  DteNetPromoter,
  ExpoCombine,
  Sentiment,
  SentimentMatt,
  VttTranslation,
} from '../Reports/index';
import ScormWrapper from '../Reports/ScormWrapper/ScormWrapper';

const Report = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const axiosPrivate = useAxiosPrivate();
  const [isAllowed, setIsAllowed] = useState(false);
  const [loading, setLoading] = useState(false);

  const goBack = () => navigate(-1);

  useEffect(() => {
    // @ts-expect-error
    document.querySelector('main').style.backgroundColor = 'white';
  }, []);

  // Checks if user has access to the report
  useEffect(() => {
    if (!state) navigate('/home');
    setLoading(true);
    const checkPermissions = async () => {
      try {
        const response = await axiosPrivate.post('/verify-report', {
          reportId: state.id,
        });
        // 'access granted'
        if (response.status === 200) {
          setIsAllowed(true);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    };
    checkPermissions();
  }, [axiosPrivate, navigate, state]);

  const renderReport = (id: string) => {
    if (id === 'pm_enrollment') {
      return <PmEnrollment />;
    }
    if (id === 'combine_excel') {
      return <CombineExcel />;
    }
    if (id === 'expo_compile') {
      return <ExpoCompile />;
    }
    if (id === 'error_checking') {
      return <ErrorChecking />;
    }
    if (id === 'dte_net_promoter') {
      return <DteNetPromoter />;
    }
    if (id === 'expo_combine') {
      return <ExpoCombine />;
    }
    if (id === 'sentiment') {
      return <Sentiment />;
    }
    if (id === 'sentiment_matt') {
      return <SentimentMatt />;
    }
    if (id === 'scorm_wrapper') {
      return <ScormWrapper />;
    }
    if (id === 'vtt_translation') {
      return <VttTranslation />;
    }
    console.error('Report not found');
    // TODO: redirect to report not found page
    return <Unauthorized />;
  };

  if (loading) return <Loader />;

  if (!isAllowed) return <Unauthorized />;

  return (
    <Box sx={{ width: '800px' }}>
      <Box sx={{ marginY: theme.spacing(3) }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h4">{state.title}</Typography>
          <Button variant="contained" color="black" onClick={goBack}>
            Go Back
          </Button>
        </Box>
        <Typography variant="subtitle1">{state.description}</Typography>
      </Box>

      {renderReport(state.id)}
    </Box>
  );
};

export default Report;
